/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempChevronsDropdownSmall: {
  name: 'temp-chevrons-dropdown-small';
  data: string;
} = {
  name: 'temp-chevrons-dropdown-small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.92 10h-3.84a1 1 0 0 0-.78 1.625l1.92 2.399a1 1 0 0 0 1.56 0l1.92-2.4A1 1 0 0 0 13.92 10Z" fill="currentColor"/></svg>`,
};
